"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalRoot = void 0;
const react_1 = require("react");
exports.ModalRoot = (0, react_1.memo)(({ onMount, onUnmount, children }) => {
    (0, react_1.useEffect)(() => {
        onMount();
    }, [onMount]);
    /**
     * In this case, it is recommended to use the useLayoutEffect hook because
     * the onUnmount() function uses a reference to the DIV element
     * which becomes null inside useEffect. This happens because useEffect
     * performs DOM manipulations first, which can lead to errors when
     * using a reference to an element that no longer exists in the DOM.
     */
    (0, react_1.useLayoutEffect)(() => {
        return () => {
            onUnmount();
        };
    }, [onUnmount]);
    return children;
});
exports.ModalRoot.displayName = 'ModalRoot';
//# sourceMappingURL=ModalRoot.js.map